import { NotificationService } from "./../../notification/notification.service";
import { Component, Input } from "@angular/core";
import { DetailedWatch, Watch } from "../../../models/watch";
import { ActivatedRoute } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { WatchService } from "../../../services/watch.service";
import { BrandService } from "../../../services/brand.service";

@Component({
  selector: "app-watch-detail",
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatTabsModule, MatTooltipModule],
  templateUrl: "./watch-detail.component.html",
  styleUrl: "./watch-detail.component.scss",
})
export class WatchDetailComponent {
  @Input() watch: DetailedWatch | null = null;
  selectedIndex = 0;
  lastIndex = 0;
  isFavorite = false;
  brandName: string | null = null;
  caseMaterial: string | null = null; // Add caseMaterial property
  

  constructor(
    private route: ActivatedRoute,
    private watchService: WatchService,
    private notification: NotificationService,
    private brandService: BrandService // Inject BrandService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const watchId = Number(params.get("id")); // Convert id to number
      if (watchId) {
        this.loadWatch(watchId);
      }
    });
  }

  loadWatch(watchId: number) { 
    this.watchService.getWatchDetailById(watchId).subscribe(
      (watch) => {

        this.watch = watch ?? null; // Assign the result to this.watch, defaulting to null if undefined
        if (watch?.watchModel.brandId) {
          this.loadBrand(watch.watchModel.brandId); // Fetch brand details
        } else {
          this.brandName = "Unknown Brand"; 
        }
        if (watch?.watchModel.caseMaterialId) {
          this.loadCaseMaterial(watch.watchModel.caseMaterialId); // Fetch case material
        } else {
          this.caseMaterial = "Unknown Material";
        }
        if (!watch) {
          this.notification.showNotification("Watch Non Found", "Error", false);
        }
      },
      (error) => {
        this.notification.showNotification("Error to Load Watch", "Error", false);
      }
    );
  }

  loadBrand(brandId: number) {
    this.brandService.getBrandById(brandId).subscribe(
      (brand) => {
        this.brandName = brand?.name ?? null; // Assign brand name or null if not found
      },
      (error) => {
        this.notification.showNotification("Error to Load Brand", "Error", false);
        this.brandName = null;
      }
    );
  }

  loadCaseMaterial(caseMaterialId: number) {
    this.watchService.getCaseMaterialById(caseMaterialId).subscribe(
      (material) => {
        this.caseMaterial = material?.material ?? "Unknown Material"; // Assign material or default to "Unknown Material"
      },
      (error) => {
        this.notification.showNotification("Error to Load Case Material", "Error", false);
        this.caseMaterial = "Unknown Material";
      }
    );
  }

  prevImage() {
    if (this.canNavigate(-1)) {
      this.selectedIndex--;
    }
  }

  nextImage() {
    if (this.canNavigate(1)) {
      this.selectedIndex++;
    }
  }

  canNavigate(direction: number): boolean {
    if (!this.watch?.primaryImageUrl?.length || this.watch.primaryImageUrl.length === 1) {
      return false;
    }

    const newIndex = this.selectedIndex + direction;
    return newIndex >= 0 && newIndex < this.watch.primaryImageUrl.length;
  }

  selectImage(index: number) {
    if (index !== this.selectedIndex) {
      this.lastIndex = this.selectedIndex;
      this.selectedIndex = index;
    }
  }
  getSlideStyle(index: number) {
    if (index === this.selectedIndex) {
      return { transform: "translateX(0)", opacity: "1" };
    } else if (index < this.selectedIndex) {
      return { transform: "translateX(-100%)", opacity: "0" };
    } else {
      return { transform: "translateX(100%)", opacity: "0" };
    }
  }
  toggleFavorite() {
    this.isFavorite = !this.isFavorite;
  }

  get primaryImageUrls(): string[] {
    if (!this.watch?.primaryImageUrl) {
      return [];
    }
    return Array.isArray(this.watch.primaryImageUrl)
      ? this.watch.primaryImageUrl
      : [this.watch.primaryImageUrl];
  }

  get shippingText(): string {
    return this.watch?.sellerCoversShipping
      ? 'Shipping Covered by Seller'
      : "Shipping Don't Cover by Seller";
  }

  get shortDescription(): string {
    const description = this.watch?.notes || '';
    return description.length > 100 ? description.substring(0, 100) + '...' : description;
  }
}
